import { DefaultLoadingManager } from "three";

const bufferCache = {};

export async function preloadAudio(url) {
  if (bufferCache[url]) return bufferCache[url];

  DefaultLoadingManager.itemStart(url);
  try {
    const res = await fetch(url);
    const buffer = await res.arrayBuffer();
    const context = new (window.AudioContext || window.webkitAudioContext)();
    const audioBuffer = await new Promise((res) =>
      context.decodeAudioData(buffer, res),
    );
    if (context.state !== "closed") await context.close();

    bufferCache[url] = audioBuffer;
    DefaultLoadingManager.itemEnd(url);
    return audioBuffer;
  } catch (err) {
    DefaultLoadingManager.itemError(url);
    throw err;
  }
}

async function createAudio(url) {
  const buffer = await preloadAudio(url);
  const context = new (window.AudioContext || window.webkitAudioContext)();
  const source = context.createBufferSource();
  source.buffer = buffer;
  source.loop = true;
  source.start(0);
  const gain = context.createGain();
  const analyser = context.createAnalyser();
  analyser.fftSize = 64;
  source.connect(analyser);
  analyser.connect(gain);
  const data = new Uint8Array(analyser.frequencyBinCount);
  return {
    context,
    source,
    gain,
    data,
    update: () => {
      analyser.getByteFrequencyData(data);
      return (data.avg = data.reduce(
        (prev, cur) => prev + cur / data.length,
        0,
      ));
    },
  };
}

export default createAudio;
